export function onRowsSelectionHandler(
  itemList,
  setSelectedRowsData,
  setSupplierButtonDisabled,
  setMaxSuppliers
) {
  return (ids) => {
    if (ids) {
      let selectedRows = [];
      let noOfSamples = [];
      ids.map((id) =>
        itemList.find(
          (row) =>
            row.id === id &&
            (selectedRows.push(row.sampleItemID),
            noOfSamples.push(row.noOfSamplesRequired - row.supplierList.length))
        )
      );

      setSelectedRowsData(selectedRows);

      selectedRows.length > 0
        ? setSupplierButtonDisabled(false)
        : setSupplierButtonDisabled(true);

      noOfSamples.length > 0 && setMaxSuppliers(Math.min(...noOfSamples));
    }
  };
}
